// TODO: REFACTORING
import React from 'react';
import InputMask from 'react-input-mask';
import Style from './style.module.css';

const TextMaskInput = ({ name, errors, ...props }) => {
  return (
    <div className={Style.textInputContainer}>
      <InputMask name={name} {...props} />
      {errors[name] && (
        <span className={Style.errorMsg}>{errors[name].message}</span>
      )}
    </div>
  );
};

export default TextMaskInput;
